import { render, staticRenderFns } from "./BasePageLayout.vue?vue&type=template&id=70973b66&"
import script from "./BasePageLayout.vue?vue&type=script&lang=js&"
export * from "./BasePageLayout.vue?vue&type=script&lang=js&"
import style0 from "./BasePageLayout.vue?vue&type=style&index=0&id=70973b66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports